export default "__VITE_ASSET__CQMnB$06__"